import CustomIcon from 'components/common/CustomIcon';
import styled from 'styled-components';
import {device} from 'styled/device';

export const BookingStatusPanelContainer = styled.div`
  display: grid;
  grid-template-columns: 37% 37% 26%;
  /* margin: 25px 10px 0 15px; */
  column-gap: 10px;
  width: 90%;
  margin: 25px auto 35px;
  max-width: 420px;
  @media (min-width: ${device.tablet}) {
    max-width: 596px;
  }

  @media (min-width: ${device.laptop}) {
    margin-bottom: 42px;
  }
`;

export const BookingStatusItem = styled.div.attrs({className: 'booking-status-item'})`
  border-right: 1px solid #b1b5c4;
  position: relative;
  @media (min-width: ${device.tablet}) {
    display: flex;
  }
  &:last-child {
    border: none;
  }
`;

export const Title = styled.div.attrs({className: 'booking-status-title'})`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #777e91;
`;

export const Info = styled.div.attrs({className: 'booking-status-info'})`
  display: flex;
  align-items: center;
  gap: 14px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #152946;
  text-transform: capitalize;
  /* @media (min-width: ${device.tablet}) {
    float: right;
    margin-right: 7px;
  } */
`;

export const EditIcon = styled.img`
  width: 24px;
  cursor: pointer;
`;

export const StyledCustomIcon = styled(CustomIcon)`
  margin-right: 15px;
`;

export const IconContainer = styled.div.attrs({className: 'booking-status-icon'})`
  margin-right: 15px;
`;
